import React, { useState } from 'react';
import { User, UserRole, Student, Teacher } from '../../types';
import { XCircleIcon } from '../icons';

export const ProfileEditModal = ({ user, onClose, onUpdate }: { user: User, onClose: () => void, onUpdate: (updatedUser: User) => void }) => {
    const [formData, setFormData] = useState({ ...user });
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        try {
            await onUpdate(formData);
            onClose();
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 animate-fade-in">
            <div className="bg-white p-8 rounded-3xl w-full max-w-md shadow-2xl animate-scale-in">
                <div className="flex justify-between items-center mb-6">
                    <h3 className="text-2xl font-bold text-gray-900">Profili Düzenle</h3>
                    <button onClick={onClose} title="Kapat" className="text-gray-400 hover:text-gray-600"><XCircleIcon className="w-6 h-6" /></button>
                </div>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">Ad Soyad</label>
                        <input title="Ad Soyad" className="w-full border p-3 rounded-xl bg-gray-50 outline-none focus:ring-2 focus:ring-blue-500" value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} />
                    </div>
                    <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">E-posta</label>
                        <input type="email" title="E-posta" className="w-full border p-3 rounded-xl bg-gray-50 outline-none focus:ring-2 focus:ring-blue-500" value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} />
                    </div>
                    <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">Şifre</label>
                        <input type="password" title="Şifre" className="w-full border p-3 rounded-xl bg-gray-50 outline-none focus:ring-2 focus:ring-blue-500" value={formData.password} onChange={e => setFormData({ ...formData, password: e.target.value })} />
                    </div>
                    <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">Cep Telefonu</label>
                        <input type="tel" className="w-full border p-3 rounded-xl bg-gray-50 outline-none focus:ring-2 focus:ring-blue-500" value={formData.phoneNumber || ''} onChange={e => setFormData({ ...formData, phoneNumber: e.target.value })} placeholder="0555 555 55 55" />
                    </div>

                    {user?.role === UserRole.STUDENT && (
                        <>
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2">Sınıf</label>
                                <select title="Sınıf" className="w-full border p-3 rounded-xl bg-gray-50 outline-none focus:ring-2 focus:ring-blue-500" value={(formData as Student).grade} onChange={e => setFormData({ ...formData, grade: e.target.value })}>
                                    <option>9. Sınıf</option>
                                    <option>10. Sınıf</option>
                                    <option>11. Sınıf</option>
                                    <option>12. Sınıf</option>
                                    <option>Mezun</option>
                                </select>
                            </div>
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2">Alan</label>
                                <select title="Alan" className="w-full border p-3 rounded-xl bg-gray-50 outline-none focus:ring-2 focus:ring-blue-500" value={(formData as Student).department} onChange={e => setFormData({ ...formData, department: e.target.value })}>
                                    <option value="Sayısal">Sayısal</option>
                                    <option value="Eşit Ağırlık">Eşit Ağırlık</option>
                                    <option value="Sözel">Sözel</option>
                                    <option value="Yabancı Dil">Yabancı Dil</option>
                                </select>
                            </div>
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2">Hedef</label>
                                <input title="Hedef" className="w-full border p-3 rounded-xl bg-gray-50 outline-none focus:ring-2 focus:ring-blue-500" value={(formData as Student).goal} onChange={e => setFormData({ ...formData, goal: e.target.value })} />
                            </div>
                        </>
                    )}

                    {user?.role === UserRole.TEACHER && (
                        <div>
                            <label className="block text-sm font-bold text-gray-700 mb-2">Branş</label>
                            <input title="Branş" className="w-full border p-3 rounded-xl bg-gray-50 outline-none focus:ring-2 focus:ring-blue-500" value={(formData as Teacher).branch} onChange={e => setFormData({ ...formData, branch: e.target.value })} />
                        </div>
                    )}

                    <div className="flex gap-3 pt-4">
                        <button type="button" onClick={onClose} className="flex-1 py-3 bg-gray-100 text-gray-600 rounded-xl font-bold hover:bg-gray-200 transition-colors">İptal</button>
                        <button type="submit" disabled={loading} className="flex-1 bg-blue-600 text-white py-3 rounded-xl font-bold hover:bg-blue-700 transition-colors shadow-lg shadow-blue-200">{loading ? 'Kaydediliyor...' : 'Kaydet'}</button>
                    </div>
                </form>
            </div>
        </div>

    );
};
